import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=b581f9b8&scoped=true"
import script from "./TableHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=b581f9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b581f9b8",
  null
  
)

export default component.exports